import { useState } from 'react';

import { NgButton } from '../buttons/NgButton';

export type NgSearchInputProps = {
  onSearchKeywordChanged: (keyword: string) => void | Promise<void>;
};

export function NgSearchInput({ onSearchKeywordChanged }: NgSearchInputProps) {
  const [searchKeyword, setSearchKeyword] = useState('');

  const clearSearchKeyword = () => {
    setSearchKeyword('');
    void onSearchKeywordChanged('');
  };

  return (
    <div className="input-group input-group-sm mb-2">
      <span className="input-group-text">
        <i className="fa-regular fa-magnifying-glass" />
      </span>
      <input
        className="form-control"
        value={searchKeyword}
        onInput={(event) => {
          const keyword = event.currentTarget.value;
          setSearchKeyword(keyword);
          void onSearchKeywordChanged(keyword);
        }}
      />
      <span className="input-group-text">
        <NgButton icon="fa-regular fa-xmark" size="small" type="link" onClick={clearSearchKeyword} />
      </span>
    </div>
  );
}
